export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14876.a9d593f1.jpg";